/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AirlineResponseCriteriaResponse,
    AirlineResponseCriteriaResponseFromJSON,
    AirlineResponseCriteriaResponseFromJSONTyped,
    AirlineResponseCriteriaResponseToJSON,
    BrandAndMarketResponse,
    BrandAndMarketResponseFromJSON,
    BrandAndMarketResponseFromJSONTyped,
    BrandAndMarketResponseToJSON,
    CabinCriteriaResponse,
    CabinCriteriaResponseFromJSON,
    CabinCriteriaResponseFromJSONTyped,
    CabinCriteriaResponseToJSON,
    CharCriteriaResponse,
    CharCriteriaResponseFromJSON,
    CharCriteriaResponseFromJSONTyped,
    CharCriteriaResponseToJSON,
    CriteriaForBookingDateTimeResponse,
    CriteriaForBookingDateTimeResponseFromJSON,
    CriteriaForBookingDateTimeResponseFromJSONTyped,
    CriteriaForBookingDateTimeResponseToJSON,
    CriteriaForLocationResponse,
    CriteriaForLocationResponseFromJSON,
    CriteriaForLocationResponseFromJSONTyped,
    CriteriaForLocationResponseToJSON,
    CriteriaForRouteResponse,
    CriteriaForRouteResponseFromJSON,
    CriteriaForRouteResponseFromJSONTyped,
    CriteriaForRouteResponseToJSON,
    DateTimeCriteriaRangeResponse,
    DateTimeCriteriaRangeResponseFromJSON,
    DateTimeCriteriaRangeResponseFromJSONTyped,
    DateTimeCriteriaRangeResponseToJSON,
    FareTypeResponseCriteriaResponse,
    FareTypeResponseCriteriaResponseFromJSON,
    FareTypeResponseCriteriaResponseFromJSONTyped,
    FareTypeResponseCriteriaResponseToJSON,
    Int32CriteriaRangeResponse,
    Int32CriteriaRangeResponseFromJSON,
    Int32CriteriaRangeResponseFromJSONTyped,
    Int32CriteriaRangeResponseToJSON,
    JourneyTypeResponseCriteriaResponse,
    JourneyTypeResponseCriteriaResponseFromJSON,
    JourneyTypeResponseCriteriaResponseFromJSONTyped,
    JourneyTypeResponseCriteriaResponseToJSON,
    MarkupPriorityResponse,
    MarkupPriorityResponseFromJSON,
    MarkupPriorityResponseFromJSONTyped,
    MarkupPriorityResponseToJSON,
    MarkupTypeResponse,
    MarkupTypeResponseFromJSON,
    MarkupTypeResponseFromJSONTyped,
    MarkupTypeResponseToJSON,
    PriceBandResponseCriteriaResponse,
    PriceBandResponseCriteriaResponseFromJSON,
    PriceBandResponseCriteriaResponseFromJSONTyped,
    PriceBandResponseCriteriaResponseToJSON,
    ProviderResponse,
    ProviderResponseFromJSON,
    ProviderResponseFromJSONTyped,
    ProviderResponseToJSON,
    StringCriteriaRangeResponse,
    StringCriteriaRangeResponseFromJSON,
    StringCriteriaRangeResponseFromJSONTyped,
    StringCriteriaRangeResponseToJSON,
    StringCriteriaResponse,
    StringCriteriaResponseFromJSON,
    StringCriteriaResponseFromJSONTyped,
    StringCriteriaResponseToJSON,
    SystemContextResponse,
    SystemContextResponseFromJSON,
    SystemContextResponseFromJSONTyped,
    SystemContextResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupResponse
 */
export interface MarkupResponse {
    /**
     * 
     * @type {string}
     * @memberof MarkupResponse
     */
    markupId?: string;
    /**
     * 
     * @type {BrandAndMarketResponse}
     * @memberof MarkupResponse
     */
    brandMarket?: BrandAndMarketResponse;
    /**
     * 
     * @type {Array<StringCriteriaResponse>}
     * @memberof MarkupResponse
     */
    accountCodes?: Array<StringCriteriaResponse> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupResponse
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<CharCriteriaResponse>}
     * @memberof MarkupResponse
     */
    bookingClasses?: Array<CharCriteriaResponse> | null;
    /**
     * 
     * @type {Array<CriteriaForBookingDateTimeResponse>}
     * @memberof MarkupResponse
     */
    bookingDateTimes?: Array<CriteriaForBookingDateTimeResponse> | null;
    /**
     * 
     * @type {Array<PriceBandResponseCriteriaResponse>}
     * @memberof MarkupResponse
     */
    bookingPriceBands?: Array<PriceBandResponseCriteriaResponse> | null;
    /**
     * 
     * @type {Array<CabinCriteriaResponse>}
     * @memberof MarkupResponse
     */
    cabinClasses?: Array<CabinCriteriaResponse> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupResponse
     */
    description?: string | null;
    /**
     * 
     * @type {Array<StringCriteriaResponse>}
     * @memberof MarkupResponse
     */
    fareBasisCodes?: Array<StringCriteriaResponse> | null;
    /**
     * 
     * @type {Array<FareTypeResponseCriteriaResponse>}
     * @memberof MarkupResponse
     */
    fareTypes?: Array<FareTypeResponseCriteriaResponse> | null;
    /**
     * 
     * @type {Array<StringCriteriaRangeResponse>}
     * @memberof MarkupResponse
     */
    flightNumbers?: Array<StringCriteriaRangeResponse> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupResponse
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupResponse
     */
    isExclusionRule?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupResponse
     */
    includeTax?: boolean;
    /**
     * 
     * @type {Array<JourneyTypeResponseCriteriaResponse>}
     * @memberof MarkupResponse
     */
    journeyTypes?: Array<JourneyTypeResponseCriteriaResponse> | null;
    /**
     * 
     * @type {Array<CriteriaForLocationResponse>}
     * @memberof MarkupResponse
     */
    locations?: Array<CriteriaForLocationResponse> | null;
    /**
     * 
     * @type {Array<AirlineResponseCriteriaResponse>}
     * @memberof MarkupResponse
     */
    marketingAirlines?: Array<AirlineResponseCriteriaResponse> | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupResponse
     */
    markupAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MarkupResponse
     */
    markupPercentage?: number;
    /**
     * 
     * @type {Array<Int32CriteriaRangeResponse>}
     * @memberof MarkupResponse
     */
    passengerAges?: Array<Int32CriteriaRangeResponse> | null;
    /**
     * 
     * @type {MarkupPriorityResponse}
     * @memberof MarkupResponse
     */
    priority?: MarkupPriorityResponse;
    /**
     * 
     * @type {MarkupTypeResponse}
     * @memberof MarkupResponse
     */
    markupType?: MarkupTypeResponse;
    /**
     * 
     * @type {Array<CriteriaForRouteResponse>}
     * @memberof MarkupResponse
     */
    routes?: Array<CriteriaForRouteResponse> | null;
    /**
     * 
     * @type {Array<ProviderResponse>}
     * @memberof MarkupResponse
     */
    suppliers?: Array<ProviderResponse> | null;
    /**
     * 
     * @type {SystemContextResponse}
     * @memberof MarkupResponse
     */
    systemContext?: SystemContextResponse;
    /**
     * 
     * @type {Array<StringCriteriaResponse>}
     * @memberof MarkupResponse
     */
    ticketDesignators?: Array<StringCriteriaResponse> | null;
    /**
     * 
     * @type {Array<DateTimeCriteriaRangeResponse>}
     * @memberof MarkupResponse
     */
    travelDateTimes?: Array<DateTimeCriteriaRangeResponse> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupResponse
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupResponse
     */
    effective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupResponse
     */
    enabled?: boolean;
}

export function MarkupResponseFromJSON(json: any): MarkupResponse {
    return MarkupResponseFromJSONTyped(json, false);
}

export function MarkupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'markupId': !exists(json, 'markupId') ? undefined : json['markupId'],
        'brandMarket': !exists(json, 'brandMarket') ? undefined : BrandAndMarketResponseFromJSON(json['brandMarket']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(StringCriteriaResponseFromJSON)),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : (json['bookingClasses'] === null ? null : (json['bookingClasses'] as Array<any>).map(CharCriteriaResponseFromJSON)),
        'bookingDateTimes': !exists(json, 'bookingDateTimes') ? undefined : (json['bookingDateTimes'] === null ? null : (json['bookingDateTimes'] as Array<any>).map(CriteriaForBookingDateTimeResponseFromJSON)),
        'bookingPriceBands': !exists(json, 'bookingPriceBands') ? undefined : (json['bookingPriceBands'] === null ? null : (json['bookingPriceBands'] as Array<any>).map(PriceBandResponseCriteriaResponseFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinCriteriaResponseFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : (json['fareBasisCodes'] === null ? null : (json['fareBasisCodes'] as Array<any>).map(StringCriteriaResponseFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(FareTypeResponseCriteriaResponseFromJSON)),
        'flightNumbers': !exists(json, 'flightNumbers') ? undefined : (json['flightNumbers'] === null ? null : (json['flightNumbers'] as Array<any>).map(StringCriteriaRangeResponseFromJSON)),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'isExclusionRule': !exists(json, 'isExclusionRule') ? undefined : json['isExclusionRule'],
        'includeTax': !exists(json, 'includeTax') ? undefined : json['includeTax'],
        'journeyTypes': !exists(json, 'journeyTypes') ? undefined : (json['journeyTypes'] === null ? null : (json['journeyTypes'] as Array<any>).map(JourneyTypeResponseCriteriaResponseFromJSON)),
        'locations': !exists(json, 'locations') ? undefined : (json['locations'] === null ? null : (json['locations'] as Array<any>).map(CriteriaForLocationResponseFromJSON)),
        'marketingAirlines': !exists(json, 'marketingAirlines') ? undefined : (json['marketingAirlines'] === null ? null : (json['marketingAirlines'] as Array<any>).map(AirlineResponseCriteriaResponseFromJSON)),
        'markupAmount': !exists(json, 'markupAmount') ? undefined : json['markupAmount'],
        'markupPercentage': !exists(json, 'markupPercentage') ? undefined : json['markupPercentage'],
        'passengerAges': !exists(json, 'passengerAges') ? undefined : (json['passengerAges'] === null ? null : (json['passengerAges'] as Array<any>).map(Int32CriteriaRangeResponseFromJSON)),
        'priority': !exists(json, 'priority') ? undefined : MarkupPriorityResponseFromJSON(json['priority']),
        'markupType': !exists(json, 'markupType') ? undefined : MarkupTypeResponseFromJSON(json['markupType']),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(CriteriaForRouteResponseFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(ProviderResponseFromJSON)),
        'systemContext': !exists(json, 'systemContext') ? undefined : SystemContextResponseFromJSON(json['systemContext']),
        'ticketDesignators': !exists(json, 'ticketDesignators') ? undefined : (json['ticketDesignators'] === null ? null : (json['ticketDesignators'] as Array<any>).map(StringCriteriaResponseFromJSON)),
        'travelDateTimes': !exists(json, 'travelDateTimes') ? undefined : (json['travelDateTimes'] === null ? null : (json['travelDateTimes'] as Array<any>).map(DateTimeCriteriaRangeResponseFromJSON)),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function MarkupResponseToJSON(value?: MarkupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'markupId': value.markupId,
        'brandMarket': BrandAndMarketResponseToJSON(value.brandMarket),
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(StringCriteriaResponseToJSON)),
        'comment': value.comment,
        'bookingClasses': value.bookingClasses === undefined ? undefined : (value.bookingClasses === null ? null : (value.bookingClasses as Array<any>).map(CharCriteriaResponseToJSON)),
        'bookingDateTimes': value.bookingDateTimes === undefined ? undefined : (value.bookingDateTimes === null ? null : (value.bookingDateTimes as Array<any>).map(CriteriaForBookingDateTimeResponseToJSON)),
        'bookingPriceBands': value.bookingPriceBands === undefined ? undefined : (value.bookingPriceBands === null ? null : (value.bookingPriceBands as Array<any>).map(PriceBandResponseCriteriaResponseToJSON)),
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinCriteriaResponseToJSON)),
        'description': value.description,
        'fareBasisCodes': value.fareBasisCodes === undefined ? undefined : (value.fareBasisCodes === null ? null : (value.fareBasisCodes as Array<any>).map(StringCriteriaResponseToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(FareTypeResponseCriteriaResponseToJSON)),
        'flightNumbers': value.flightNumbers === undefined ? undefined : (value.flightNumbers === null ? null : (value.flightNumbers as Array<any>).map(StringCriteriaRangeResponseToJSON)),
        'isDeleted': value.isDeleted,
        'isExclusionRule': value.isExclusionRule,
        'includeTax': value.includeTax,
        'journeyTypes': value.journeyTypes === undefined ? undefined : (value.journeyTypes === null ? null : (value.journeyTypes as Array<any>).map(JourneyTypeResponseCriteriaResponseToJSON)),
        'locations': value.locations === undefined ? undefined : (value.locations === null ? null : (value.locations as Array<any>).map(CriteriaForLocationResponseToJSON)),
        'marketingAirlines': value.marketingAirlines === undefined ? undefined : (value.marketingAirlines === null ? null : (value.marketingAirlines as Array<any>).map(AirlineResponseCriteriaResponseToJSON)),
        'markupAmount': value.markupAmount,
        'markupPercentage': value.markupPercentage,
        'passengerAges': value.passengerAges === undefined ? undefined : (value.passengerAges === null ? null : (value.passengerAges as Array<any>).map(Int32CriteriaRangeResponseToJSON)),
        'priority': MarkupPriorityResponseToJSON(value.priority),
        'markupType': MarkupTypeResponseToJSON(value.markupType),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(CriteriaForRouteResponseToJSON)),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(ProviderResponseToJSON)),
        'systemContext': SystemContextResponseToJSON(value.systemContext),
        'ticketDesignators': value.ticketDesignators === undefined ? undefined : (value.ticketDesignators === null ? null : (value.ticketDesignators as Array<any>).map(StringCriteriaResponseToJSON)),
        'travelDateTimes': value.travelDateTimes === undefined ? undefined : (value.travelDateTimes === null ? null : (value.travelDateTimes as Array<any>).map(DateTimeCriteriaRangeResponseToJSON)),
        'deleted': value.deleted,
        'effective': value.effective,
        'enabled': value.enabled,
    };
}


